<template>
  <div class="maskComp" @click="onClick" v-if="checkMask(show)"></div>
</template>

<script>
export default {
  name: 'maskComp',
  props: {
    show: {
      type: Object,
      default: null
    }
  },

  methods: {
    onClick() {
      this.$emit('close');
    },

    checkMask() {
      const { show } = this;
      if(!show) return false;
      var result = false;
      for(let key in show){
        result = result || (typeof show[key] == 'boolean' ? show[key] : (show[key] != -1));
      }
      return result;
    },
  }
}
</script>

<style>
.maskComp{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  background-color: #00000000;
}
</style>